import type {PropsAdaptiveStyle} from '../hooks/useGetAdaptiveStyle'

export const adaptiveStyleConfig: PropsAdaptiveStyle = [
    {
      cssKey: 'marginLeft',
      axis: 'width',
      params: [8, 6, 5, 2, 0, 0, 0],
    },
    {
      cssKey: 'marginRight',
      axis: 'width',
      params: [8, 6, 5, 2, 0, 0, 0],
    },
    {
      cssKey: 'marginTop',
      axis: 'height',
      params: [8, 6, 5, 2, 2, 2, 2],
    },
    {
      cssKey: 'marginBottom',
      axis: 'height',
      params: [8, 6, 5, 2, 2, 2, 2],
    },
    {
      cssKey: 'width',
      axis: 'width',
      params: [28, 28, 28, 28, 28, 28, 28],
    },
    {
      cssKey: 'height',
      axis: 'height',
      params: [46, 46, 46, 46, 46, 46, 46],
      onlyMobile: true,
    },
    {
      cssKey: 'height',
      axis: 'height',
      params: [24, 20, 16, 14, 12, 10, 10],
      onlyDesktop: true,
    },
    {
      cssKey: 'fontSize',
      axis: 'height',
      params: [20, 20, 20, 16, 14, 12, 12],
      onlyDesktop: true,
    }
  ]
